import { useContext as _useContext, createContext as _createContext } from 'react'

// Wrapper functions
export function useContext<T>(context: React.Context<T | undefined>) {
  const value = _useContext(context)
  if (value === undefined) throw new Error('context must be within provider')
  return value
}

export function createContext<T>(value: T | undefined = undefined) {
  return _createContext<T | undefined>(value)
}
